// === Utility helpers ===

const allTodos = {
  notarize: [
    {
      step: 1,
      msg: "Select at least one action",
      active: true,
      completed: false,
    },
    {
      step: 2,
      msg: "Draw notary seal and signature areas on the document",
      active: true,
      completed: false,
    },
    {
      step: 3,
      msg: "Notary seal and signature must be added as a pair",
      active: true,
      completed: false,
    },
    {
      step: 4,
      msg: "Draw a signature area for at least one signer on the document",
      active: true,
      completed: false,
    },
    {
      hint: 1,
      msg: "Document must include property, owner, and all required information",
    },
    {
      hint: 2,
      msg: "Document is not previously notarized",
    },
    {
      hint: 3,
      msg: "Document is not previously recorded",
    },
  ],
  sign: [
    {
      step: 1,
      msg: "Select at least one action",
      active: true,
      completed: false,
    },
    {
      step: 2,
      msg: "Draw a signature area for at least one signer on the document",
      active: true,
      completed: false,
    },
    {
      step: 3,
      msg: "No newly drawn notary seals or signatures on the document",
      active: true,
      completed: false,
    },
    {
      hint: 1,
      msg: "Document is not previously notarized",
    },
    {
      hint: 2,
      msg: "Document is not previously recorded",
    },
  ],
  record: [
    {
      step: 1,
      msg: "Select at least one action",
      active: true,
      completed: false,
    },
    {
      step: 2,
      msg: "Document must be notice of commencement",
      active: true,
      completed: false,
    },
    {
      step: 3,
      msg: "No newly drawn signatures on the document",
      active: true,
      completed: false,
    },
    {
      step: 4,
      msg: "No newly drawn notary seals or signatures on the document",
      active: true,
      completed: false,
    },
    {
      hint: 1,
      msg: "Document must already be notarized and valid",
    },
    {
      hint: 2,
      msg: "Document must include property, owner, and all required information",
    },
    {
      hint: 3,
      msg: "Document is not previously recorded",
    },
  ],
  notarizeRecord: [
    {
      step: 1,
      msg: "Select at least one action",
      active: true,
      completed: false,
    },
    {
      step: 2,
      msg: "Document must be notice of commencement",
      active: true,
      completed: false,
    },
    {
      step: 3,
      msg: "Draw notary seal and signature areas on the document",
      active: true,
      completed: false,
    },
    {
      step: 4,
      msg: "Notary seal and signature must be added as a pair",
      active: true,
      completed: false,
    },
    {
      step: 5,
      msg: "Draw a signature area for at least one signer on the document",
      active: true,
      completed: false,
    },
    {
      hint: 1,
      msg: "Document must include property, owner, and all required information",
    },
    {
      hint: 2,
      msg: "Document is not previously notarized",
    },
    {
      hint: 3,
      msg: "Document is not previously recorded",
    },
  ],
};

export const areAllOptionsFalse = (options = {}) =>
  Object.values(options).every((value) => value === false);

export const normalizeName = (name) => {
  const parts = name?.split("_");
  if (!parts || parts.length === 0) return name;
  return parts.length === 3
    ? parts.slice(0, 2).join("_")
    : parts.length === 4
    ? parts.slice(0, 3).join("_")
    : name;
};

export const fieldMap = [
  "notary_seal_a",
  "notary_sign_a",
  "notary_seal_b",
  "notary_sign_b",
  "sign_a",
  "sign_b",
  "sign_c",
];

export const filterDefBoxes = (formFields = [], map = fieldMap) => {
  const filtered = formFields
    ?.map((field) => normalizeName(field.name))
    .filter((normalizedName) => map.includes(normalizedName));

  return filtered?.length > 0 ? filtered : [];
};

// === Notary validation ===
export const validateNotaryPairs = (addedDefaultBoxes = []) => {
  const requiredNotaryA = ["notary_seal_a", "notary_sign_a"];
  const requiredNotaryB = ["notary_seal_b", "notary_sign_b"];

  const hasFullNotaryA = requiredNotaryA.every((val) =>
    addedDefaultBoxes.includes(val)
  );
  const hasFullNotaryB = requiredNotaryB.every((val) =>
    addedDefaultBoxes.includes(val)
  );
  const hasPartialNotaryB =
    requiredNotaryB.some((val) => addedDefaultBoxes.includes(val)) &&
    !hasFullNotaryB;

  if (!hasFullNotaryA) {
    return {
      valid: false,
      message: "Notary fields must be added to the PDF before proceeding",
    };
  }

  if (hasPartialNotaryB) {
    return {
      valid: false,
      message:
        "Please add both seal and signature for the second Notary on the PDF, or remove it.",
    };
  }

  return {
    valid: true,
    hasFullNotaryA,
    hasFullNotaryB,
    message: "Valid notary setup.",
  };
};

export const getLockValidationTodos = ({
  currentProcessingFile,
  selectedPackageForm,
  showSigner1,
  showSigner2,
  showSigner3,
}) => {
  const options = selectedPackageForm?.actions || {};
  const addedDefaultBoxes = filterDefBoxes(
    currentProcessingFile?.document?.tempFields?.formFields,
    fieldMap
  );

  const hasAtLeastOneSigner = showSigner1 || showSigner2 || showSigner3;

  const notaryValidation = validateNotaryPairs(addedDefaultBoxes);
  const hasNotaryBoxes =
    addedDefaultBoxes.includes("notary_seal_a") &&
    addedDefaultBoxes.includes("notary_sign_a");

  // Determine mode
  const { notarize, sign, record } = options;

  const key =
    notarize && record
      ? "notarizeRecord"
      : record
      ? "record"
      : notarize
      ? "notarize"
      : sign
      ? "sign"
      : null;

  if (!key) {
    return {
      valid: false,
      steps: [
        {
          step: 1,
          msg: "Select at least one action",
          active: true,
          completed: false,
        },
      ],
      hints: [],
      allCompleted: false,
    };
  }

  // Clone and map current step list
  const steps = allTodos[key]
    .filter((item) => item.step)
    .map((step) => {
      let completed = false;

      // === Match validation per msg content ===
      if (step.msg.includes("Select at least one action")) {
        completed = !areAllOptionsFalse(options);
      }

      if (
        step.msg.includes("Draw notary seal") ||
        step.msg.includes("Add Notary")
      ) {
        completed = hasNotaryBoxes;
      }

      if (
        step.msg.includes("Notary seal and signature must be added as a pair")
      ) {
        completed = notaryValidation?.valid;
      }

      if (
        step.msg.includes("signature area for at least one signer") ||
        step.msg.includes("Add a signature area")
      ) {
        completed = hasAtLeastOneSigner;
      }

      if (
        step.msg.includes("No newly drawn notary") &&
        !addedDefaultBoxes.some((b) => b.includes("notary"))
      ) {
        completed = true;
      }

      if (
        step.msg.includes("No newly drawn signatures") &&
        !addedDefaultBoxes.some((b) => b.includes("sign"))
      ) {
        completed = true;
      }

      if (
        step.msg.includes("notice of commencement") &&
        currentProcessingFile?.document?.document_name
          ?.toLowerCase()
          .includes("affidavit")
      ) {
        completed = false;
      } else if (step.msg.includes("notice of commencement")) {
        completed = currentProcessingFile?.document?.is_notice_of_commencement;
      }

      return {
        ...step,
        completed,
      };
    });

  const hints = allTodos[key].filter((item) => item.hint);
  const allCompleted = steps.every((s) => s.completed);

  return {
    valid: allCompleted,
    steps,
    hints,
    allCompleted,
  };
};

export const customDocumentsNocTodos = ({
  currentProcessingFile,
  showSigner1,
}) => {
  const options = currentProcessingFile?.document?.actions || {};
  const addedDefaultBoxes = filterDefBoxes(
    currentProcessingFile?.document?.tempFields?.formFields,
    fieldMap
  );
  const notaryValidation = validateNotaryPairs(addedDefaultBoxes);

  const hasAtLeastOneSigner = showSigner1;

  const hasNotaryBoxes =
    addedDefaultBoxes.includes("notary_seal_a") &&
    addedDefaultBoxes.includes("notary_sign_a");

  // Determine mode
  const { notarize, record } = options;

  const key =
    notarize && record
      ? "notarizeRecord"
      : record
      ? "record"
      : notarize
      ? "notarize"
      : null;

  if (!key) {
    return {
      valid: false,
      steps: [
        {
          step: 1,
          msg: "Select at least one action",
          active: true,
          completed: false,
        },
      ],
      hints: [],
      allCompleted: false,
    };
  }

  // Clone and map current step list
  const steps = allTodos[key]
    .filter(
      (item) =>
        item.step && !item.msg.toLowerCase().includes("notice of commencement")
    )
    .map((step) => {
      let completed = false;
      let showHow = "";

      // === Match validation per msg content ===
      if (step.msg.includes("Select at least one action")) {
        completed = !areAllOptionsFalse(options);
      }

      if (
        step.msg.includes("Draw notary seal") ||
        step.msg.includes("Add Notary")
      ) {
        completed = hasNotaryBoxes;
        showHow = "/demo_videos/notary_field_demo.mp4";
      }

      if (
        step.msg.includes("Notary seal and signature must be added as a pair")
      ) {
        completed = notaryValidation?.valid;
      }

      if (
        step.msg.includes("signature area for at least one signer") ||
        step.msg.includes("Add a signature area")
      ) {
        completed = hasAtLeastOneSigner;
        showHow = "/demo_videos/owner_field_demo.mp4";
      }

      if (
        step.msg.includes("No newly drawn notary") &&
        !addedDefaultBoxes.some((b) => b.includes("notary"))
      ) {
        completed = true;
      }

      if (
        step.msg.includes("No newly drawn signatures") &&
        !addedDefaultBoxes.some((b) => b.includes("sign"))
      ) {
        completed = true;
      }

      if (step.msg.includes("notice of commencement")) {
        completed = true;
      }

      return {
        ...step,
        completed,
        showHow,
      };
    });

  const hints = allTodos[key].filter((item) => item.hint);
  const allCompleted = steps.every((s) => s.completed);

  return {
    valid: allCompleted,
    steps,
    hints,
    allCompleted,
  };
};
